<template lang='pug'>
van-popup.modal(v-model='show')
    .content-wrapper
        .content-head
            van-icon(name='close', color='#fff', @click='close')
        slot
</template>

<script>
export default {
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    methods:{
        close(){
            this.show=!this.show
        }
    },
    computed: {
        show: {
            get() {
                return this.visible
            },
            set(v) {
                this.$emit('update:visible', v)
            }
        }
    }
}
</script>

<style scoped lang='less'>
.content-wrapper {
    width: 12rem;
    .content-head {
        background: @themeColor;
        padding: @padding-base @padding-xs;
        display: flex;
        justify-content: flex-end;
        font-size: 1rem;
        i{
            cursor: pointer;
        }
    }
}
</style>